import { Modal } from '@platform/components';

const EnvelopeSVG = () => {
  return (
    <svg
      width='100'
      height='100'
      viewBox='0 0 100 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_413_2256)'>
        <path
          d='M100 43.775V89.669C100 95.3715 95.1976 100 89.2806 100H10.7194C4.80243 100 0 95.3715 0 89.669V43.775L42.4519 3.01728C46.6261 -1.00576 53.3941 -1.00576 57.5886 3.01728L100 43.775Z'
          fill='#FF9D00'
        />
        <path
          d='M19.1084 11.5127H81.0132C86.9301 11.5127 91.7325 16.1411 91.7325 21.8437V81.5059C91.7325 87.2084 86.9301 91.8369 81.0132 91.8369H19.1084C13.1915 91.8369 8.38904 87.2084 8.38904 81.5059V21.8242C8.38904 16.1216 13.1915 11.5127 19.1084 11.5127Z'
          fill='#F4EEE6'
        />
        <path
          d='M100 43.7754V89.6693C100 95.3719 95.1976 100 89.2806 100H10.7194C4.80243 100 0 95.3719 0 89.6693V43.9121L49.9291 92.0324L100 43.7754Z'
          fill='#FFBE1D'
        />
        <path
          d='M96.8997 96.953C95.2179 98.5935 92.9484 99.6871 90.4357 99.9606L10.3546 99.9996C7.53803 99.902 4.98484 98.7497 3.12061 96.953L42.4316 59.0661C46.6059 55.0431 53.3942 55.0431 57.5887 59.0661L96.8997 96.953Z'
          fill='#FFE000'
        />
        <path
          d='M50.0102 50.981C59.8696 50.981 67.8622 43.2779 67.8622 33.7757C67.8622 24.2734 59.8696 16.5703 50.0102 16.5703C40.1507 16.5703 32.1581 24.2734 32.1581 33.7757C32.1581 43.2779 40.1507 50.981 50.0102 50.981Z'
          fill='#00BF00'
        />
        <path
          d='M60.2432 26.413C59.5542 25.749 58.4194 25.749 57.7102 26.413L46.2411 37.4666L42.2492 33.6194C41.5805 32.9749 40.4661 32.9749 39.7974 33.6194L39.7568 33.6584C39.0476 34.342 39.0476 35.4356 39.7568 36.0996L44.9645 41.1186C45.6535 41.7826 46.7882 41.7826 47.4975 41.1186L60.2432 28.8347C60.9524 28.1707 60.9524 27.077 60.2432 26.413Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_413_2256'>
          <rect width='100' height='100' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

/** A confirmation dialog that appears after sending an intro with the <SendIntroModal /> */
const IntroductionSentModal = ({
  recipientName,
  isOpen,
  setIsOpen,
}: {
  recipientName: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title='Introduction sent!'
      headerDivision='divider'
      variant='dialog'
      primaryCTA={{
        text: 'Close',
        callback: () => setIsOpen(false),
      }}
      ignoreExtraPadding
    >
      <div className='flex flex-col items-center text-center'>
        <div className='mb-6'>
          <EnvelopeSVG />
        </div>
        <p className='mb-4'>
          {recipientName} will review your introduction. If they accept, we’ll connect you over
          email and let you know next steps.
        </p>
        <p>
          To increase your chances of finding a good match, we recommend sending at least 3
          introductions.
        </p>
      </div>
    </Modal>
  );
};

export default IntroductionSentModal;
